<template>
  <div>
    <QuizEditorNav />
    <QuizStepper step="2" />
    <div class="container loader" :class="{hidden: !quizLoading}">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <div class="container" :class="{hidden: quizLoading}">
      <h2>Do you want to capture the user's name, email, and results?</h2>
      <div id="step1">
        <div class="row">
          <div class="input-field s12">
            <p>
              <label>
                <input class="with-gap" name="group3" value="required" type="radio" v-model="collect_user_information" />
                <span>Require it</span>
              </label>
            </p>
            <!--
            <p>
              <label>
                <input class="with-gap" name="group3" value="optional" type="radio" v-model="collect_user_information" />
                <span>Make it optional</span>
              </label>
            </p>
            -->
            <p>
              <label>
                <input class="with-gap" name="group3" value="do_not_collect" text="no" type="radio" v-model="collect_user_information"/>
                <span>No</span>
              </label>
            </p>
            <br>
            
          </div>
        </div>
        <div class="fab-next">
          <a
            class="btn btn-large blue"
            :class="{disabled: !canGoNext || quizLoading}"
            @click="captureCollectUserInformationResults()"
          >Continue
            <i class=" material-icons right" v-if="!loadingSteps">chevron_right</i>
            <div class="preloader-wrapper small active" v-if="loadingSteps">
              <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div>
                <div class="gap-patch">
                  <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import QuizEditorNav from "@/components/QuizEditorNav";
import QuizStepper from "@/components/QuizStepper";

import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
//import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"

import 'isomorphic-fetch'

let gql_endpoint = process.env.GQL_ENDPOINT
let gqlv2_endpoint = process.env.GQL_V2_ENDPOINT
let read_gql_endpoint = process.env.READGQL_ENDPOINT

var draftFields = [
  "steps",
  "description",
  "title",
  "time_to_complete",
  "video_url",
  "thumbnail_url",
  "browser_title",
  "raw_url",
  "video_duration"
];

export default {
  mounted() {
    let self = this
    document.title = "fyiio | quiz editor";
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    });
    setTimeout(function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    }, 500);

    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email']

          if (self.id) {
            self.loadQuiz();
          } else {
            self.quizLoading = false;
          }
        });
      }
    });
  },
  updated() {},
  name: "NewQuizTemplate",
  data() {
    return {
      record_user_results: true,
      title: "",
      description: "",
      article_id: this.$route.params.article_id,
      time_to_complete: "",
      collect_user_information: "",
      quiz: "",
      id: this.$route.params.id,
      user_id: false,
      draft: false,
      user_org: false,
      originalQuiz: false,
      user_email: false,
      loadingSteps: false,
      quizLoading: true,
      timeToComplete: [
        "1 MINUTE",
        "2 MINUTES",
        "3 MINUTES",
        "4 MINUTES",
        "5 MINUTES",
        "10 MINUTES",
        "15 MINUTES",
        "30 MINUTES",
        "60+ MINUTES"
      ]
    };
  },
  computed: {
    canGoNext() {
      return (
        this.collect_user_information
      );
    }
  },
  methods: {
    loadQuiz(){
      let self = this;
      GqlV2Query.getQuiz(this.id,  (err, result) => {
        let quiz=result.data.quiz[0];
        self.quiz=quiz;
        self.originalQuiz = quiz;
        self.title=quiz.title;
        self.collect_user_information=quiz.collect_user_information;
        self.description=quiz.description;
        self.time_to_complete=quiz.time_to_complete;
        self.quizLoading = false;
        M.AutoInit();
      });
    },
    captureCollectUserInformationResults() {
      var self = this;
      if (!this.canGoNext) {
        return;
      }
      this.loadingSteps = true;
      if (this.quiz) {
        let variablesOld = self.originalQuiz;
        let variables = {}
        variables.id=self.originalQuiz.id;
        variables.collect_user_information=self.collect_user_information;
        
        GqlV2Query.updateQuiz(variables, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
              inDuration: 3000
            });
          } else {
            window.location = "/quizzes/build/question/" + self.id;
          }
        });
      } else {
        let variables = {
          title: this.title,
          description: this.description,
          organization_id: this.organization_id,
          time_to_complete: this.time_to_complete
        };
        //variables.quiz_author_id = self.user_id;
        //alert(GqlV2Query)
        GqlV2Query.newQuiz(variables, (err, result) => {
          if (err) {
            this.error = err;
          } else {
            window.location =
              "/quizzes/build/question/" + result.data.insert_quiz_one.id;
          }
        });
      }
    }
  },
  components: {
    QuizEditorNav,
    QuizStepper
  }
};
</script>

<style scoped>
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
.preloader-wrapper {
  margin-top: 9px;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete {
  width: 352px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.hidden {
  display: none;
}
.loader {
  margin-top: 100px;
}
.select-wrapper input.select-dropdown,
.dropdown-content li > span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}

.fab-next {
  float: right;
  padding-top: 42px;
  padding-bottom: 42px;
}
#description {
  margin-top: 8px;
}
</style>
<style >
.select-wrapper input.select-dropdown {
  text-transform: lowercase !important;
}
.select-wrapper .dropdown-content li > span,
ul.dropdown-content.select-dropdown li span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}
.btn-floating.blue {
  background-color: #58595b !important;
}
.btn-floating.blue.disabled {
  background-color: #f1f1f1 !important;
}

.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
</style>


// WEBPACK FOOTER //
// src/containers/dashboard/quizzes/BuildQuiz.vue